import React, { useState } from "react";
import { cash } from "../../services/api";
import { reservationsAPI } from "../../services/portalApi";

/** Send the guest to Stripe's payment page for this reservation. Throws with a readable message. */
export const startCardPayment = async (ref, amount = "now") => {
  const { url } = await reservationsAPI.cardCheckout(ref, amount);
  if (!url) throw new Error("Card payment couldn't be started just now. Please try again.");
  window.location.assign(url);
};

/**
 * "Pay by card" for a reservation: what's due now, and the whole balance
 * when that's more. Card details are entered on Stripe's own page, never
 * here. Renders nothing when card isn't on offer or nothing is owed.
 */
const CardPay = ({ r }) => {
  const [busy, setBusy] = useState("");
  const [error, setError] = useState("");
  const due = r.payable || { now: 0, balance: 0 };
  if (!r.cardPayments || !(due.balance > 0)) return null;
  const now = due.now > 0 ? due.now : due.balance;

  const pay = async (amount) => {
    setBusy(amount); setError("");
    try { await startCardPayment(r.ref, amount); }
    catch (err) { setError(err.message); setBusy(""); }
  };

  return (
    <div className="rv-pay">
      <div className="mk-actions">
        <button type="button" className="mk-btn mk-btn--primary" disabled={!!busy} onClick={() => pay("now")}>
          {busy === "now" ? "Opening secure payment…" : `Pay ${cash(now)} by card`}
        </button>
        {due.balance > now + 0.005 && (
          <button type="button" className="mk-btn mk-btn--ghost" disabled={!!busy} onClick={() => pay("balance")}>
            {busy === "balance" ? "Opening…" : `Pay the full ${cash(due.balance)}`}
          </button>
        )}
      </div>
      <p className="rv-pay-note">You'll pay on Stripe's secure page and come straight back here.</p>
      {error && <p className="mk-error mb-0" role="alert">{error}</p>}
    </div>
  );
};

export default CardPay;
